// extracted by mini-css-extract-plugin
export default {"root":"InviteToTeamPage_root__JEHCp"};